import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const getFechaSalida = async(IdPersonalPayrolls) => {
    const result = await PrivateInterceptor(`Global/FechaSalida/${IdPersonalPayrolls}`, 'GET');
    return result;
};

export const getFechaCreacion = async(IdRequisa) => {
    const result = await PrivateInterceptor(`Global/FechaSalida/FechaCreacion/${IdRequisa}`, 'GET');
    return result;
}

// export const detRequisaMateriales = async (IdRequisa) => {
//     const result = await PrivateInterceptor(`Mantenimiento/Requisas/detallesRequisa/${IdRequisa}`, 'GET')
//     return result;
// }